import { useMemo } from "react";
import { defineMessages, useIntl } from "react-intl";
import { classNames } from "@ct-react/core";
import { useLocaleNavigate } from "@ct-react/locale";
import { ArticleType } from "@shared/url";
import { actions } from "../../i18n/sharable-defs";
import { AnyArticleSearch } from "../../contexts/search";
import { getEnumKeyByValue } from "../../tools/enum";
import Button from "../common/button";
import "./footer-content.scss";

const transDefs = {
  [ArticleType.SALE]: defineMessages({
    title: { id: "search.complement.sale-title", defaultMessage: "Je veux être informé dès qu'un nouveau bien est mis en vente" },
    link: { id: "search.complement.sale-link", defaultMessage: "Créer une alerte email" },
  }),
  [ArticleType.RENTAL]: defineMessages({
    title: { id: "search.complement.rental-title", defaultMessage: "Je souhaite proposer mon bien à la location" },
    card: { id: "search.complement.rental-card-title", defaultMessage: "Découvrez nos services sur mesure avec l'Ultime Expérience !" }
  })
};

type Props = {
  className?: string;
  searchState: AnyArticleSearch;
  mode?: "card" | "footer";
};

const SearchFooterContent = ({ className, searchState, mode }: Props) => {

  const intl = useIntl();
  const navigate = useLocaleNavigate();

  const text = useMemo(() => {
    if (searchState.kind === ArticleType.SALE) return transDefs[ArticleType.SALE].title;
    return (mode === "footer" || true) ? transDefs[ArticleType.RENTAL].title : transDefs[ArticleType.RENTAL].card;
  }, [ searchState.kind, mode ]);

  const link = useMemo(() => {
    if (searchState.kind === ArticleType.SALE) return transDefs[ArticleType.SALE].link;
    return (mode === "footer" || true) ? actions.contact : actions.more;
  }, [ searchState.kind, mode ]);

  const onRedirect = () => {
    switch (searchState.kind) {
      case ArticleType.SALE:
        navigate("/alert/", {
          state: {
            data: {
              articleType: searchState.kind,
              ...(!!searchState.objectTypes) && { objectTypes: searchState.objectTypes },
              ...(!!searchState.zips) && { zips: searchState.zips },
              ...(!!searchState.surface) && { surface: searchState.surface },
              ...(!!searchState.surfaceRange && searchState.surfaceRange[0] > 0) && { surface: searchState.surfaceRange[0] },
              ...(searchState.objectTypes?.includes(93) && !!searchState.plotSurface) && { surface: searchState.plotSurface },
              ...(searchState.objectTypes?.includes(93) && !!searchState.plotSurfaceRange) && { surface: searchState.plotSurfaceRange[0] },
              ...(!!searchState.rooms) && { rooms: searchState.rooms },
              ...(!!searchState.roomsRange && searchState.roomsRange[0] > 0) && { rooms: searchState.roomsRange[0] },
              ...(!!searchState.priceRange) && {
                minPrice: searchState.priceRange[0],
                maxPrice: searchState.priceRange[1],
              }
            }
          }
        });
        break;
      default:
        navigate("/contact/");
        break;
    }
  }

  const wrapperClassName = classNames("search-complement", mode,
    getEnumKeyByValue(ArticleType, searchState.kind)?.toLowerCase(), className);

  return (
    <div className={wrapperClassName}>
      <div className="image-choice" />
      <div className="inner-wrap">
        <h3>{intl.formatMessage(text)}</h3>
        <Button type="button" className="link white l-spacing"
                onClick={onRedirect}>
          {intl.formatMessage(link)}
        </Button>
      </div>
    </div>);

};

export default SearchFooterContent;
